import { runbookConstants } from "../constants/runbook.constants";

export function runbook(state = {}, action) {
  switch (action.type) {
    case runbookConstants.GET_REQUEST:
    case runbookConstants.CREATE_REQUEST:
      return {
        ...state,
        loading: true,
        request: action.payload,
        success: false,
      };
    case runbookConstants.UPDATE_REQUEST:
      return {
        ...state,
        loadingUpdate: true,
        request: action.payload,
        updateSuccess: false,
        updateError: null,
      };
    case runbookConstants.GET_SUCCESS:
      return {
        ...state,
        loading: false,
        paginatedResult: action.payload,
      };
    case runbookConstants.CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };
    case runbookConstants.UPDATE_SUCCESS:
      return {
        ...state,
        loadingUpdate: false,
        updateSuccess: true,
        updateError: null,
      };
    case runbookConstants.DELETE_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case runbookConstants.DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case runbookConstants.GET_FAILURE:
    case runbookConstants.CREATE_FAILURE:
    case runbookConstants.DELETE_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case runbookConstants.UPDATE_FAILURE:
      return {
        ...state,
        loadingUpdate: false,
        updateSuccess: false,
        updateError: true,
      };
    case runbookConstants.EXECUTE_REQUEST:
      return {
        ...state,
        loadingExecute: true,
        request: action.payload,
        executeResponse: null,
        executeError: null,
      };
    case runbookConstants.EXECUTE_SUCCESS:
      return {
        ...state,
        loadingExecute: false,
        executeResponse: action.payload,
        executeError: null,
      };
    case runbookConstants.EXECUTE_FAILURE:
      return {
        ...state,
        loadingExecute: false,
        executeResponse: null,
        executeError: action.payload,
      };
    case runbookConstants.VALIDATE_REQUEST:
      return {
        ...state,
        loadingValidate: true,
        request: action.payload,
        validateResponse: null,
        validateError: null,
      };
    case runbookConstants.VALIDATE_SUCCESS:
      return {
        ...state,
        loadingValidate: false,
        validateResponse: action.payload,
        validateError: null,
      };
    case runbookConstants.VALIDATE_FAILURE:
      return {
        ...state,
        loadingValidate: false,
        validateResponse: null,
        validateError: action.payload,
      };
    case runbookConstants.CANCEL_REQUEST:
      return {
        ...state,
        loadingCancel: true,
        cancelResponse: null,
        cancelError: null,
      };
    case runbookConstants.CANCEL_SUCCESS:
      return {
        ...state,
        loadingCancel: false,
        cancelResponse: action.payload,
        cancelError: null,
      };
    case runbookConstants.CANCEL_FAILURE:
      return {
        ...state,
        loadingCancel: false,
        cancelResponse: null,
        cancelError: action.payload,
      };
    case runbookConstants.REACTIVATE_REQUEST:
      return {
        ...state,
        loadingReactivate: true,
        reactivateResponse: null,
        reactivateError: null,
      };
    case runbookConstants.REACTIVATE_SUCCESS:
      return {
        ...state,
        loadingReactivate: false,
        reactivateResponse: action.payload,
        reactivateError: null,
      };
    case runbookConstants.REACTIVATE_FAILURE:
      return {
        ...state,
        loadingReactivate: false,
        reactivateResponse: null,
        reactivateError: action.payload,
      };
    default:
      return state;
  }
}
